import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { getCategoryGroups, getCategories, deleteCategoryGroup, deleteCategory } from "../../../store/actions";
import CategoryListing from "./categoryListing";
import AddCategoryGroupForm from "./addCategoryGroupForm";
import AddCategoryForm from "./addCategoryForm";

const CategoryGroupListing = ({ getCategories, getCategoryGroups, categoryList, categoryGroupList, onBack, deleteCategoryGroup, deleteCategory }) => {
    const [category, setCategory] = useState(null);

    useEffect(() => {
        category ? getCategories(category.id) : getCategoryGroups();
    }, [category, getCategories, getCategoryGroups]);

    const categoryOnBack = () => {
        setCategory(null);
    }

    const deleteCategoryGroupNow = (event) => {
        const successHandler = () => {
            category ? getCategories(category.id) : getCategoryGroups();
        }
        category ? deleteCategory(event, successHandler) : deleteCategoryGroup(event, successHandler);
    }

    return <div className="anim-panel">
        <div className={`panel ${category ? "active" : ""}`}>
            <CategoryListing title="Add Category" list={categoryList} item={category} onBack={categoryOnBack} deleteItem={deleteCategoryGroupNow} getList={getCategoryGroups} columns={[{
                Header: "Group",
                accessor: "id",
                width: 100,
                sortable: false,
                Cell: () => <span>{category ? category.name : ""}</span>
            }, {
                Header: "Category",
                accessor: "name"
            }, {
                Header: "Seq",
                accessor: "seq",
                width: 50,
                className: "text-center px-1",
                headerClassName: "text-center px-1",
                sortable: false
            }]} addForm={AddCategoryForm} initialFields={{
                name: "",
                seq: 1,
                group: category ? category.id : null
            }} />
        </div>
        <div className={`panel ${!category ? "active" : ""}`}>
            <CategoryListing title="Add Category Group" list={categoryGroupList} onBack={onBack} deleteItem={deleteCategoryGroupNow} getList={getCategoryGroups} columns={[{
                Header: "Group Name",
                accessor: "name",
                Cell: ({ value, original }) => <span onClick={() => setCategory(original)} className="text-primary-dark pointer">{value}</span>
            }, {
                Header: "Seq",
                accessor: "seq",
                width: 50,
                className: "text-center px-1",
                headerClassName: "text-center px-1",
                sortable: false
            }, {
                Header: "Special",
                accessor: "major",
                width: 80,
                className: "text-center px-1",
                headerClassName: "text-center px-1",
                sortable: false,
                Cell: ({ value }) => <span><i className={`text-success icon icon-${value ? "check" : ""}`} /></span>
            }, {
                Header: "Search",
                accessor: "search",
                width: 80,
                className: "text-center px-1",
                headerClassName: "text-center px-1",
                sortable: false,
                Cell: ({ value }) => <span><i className={`text-success icon icon-${value ? "check" : ""}`} /></span>
            }]} addForm={AddCategoryGroupForm} initialFields={{
                major: true,
                name: "",
                search: true,
                seq: 1
            }} />
        </div>
    </div>
}

const mapStateToProps = (state) => {
    return {
        categoryList: get(state, "AddRecipe.categoryList.results", []),
        categoryGroupList: get(state, "AddRecipe.categoryGroupList.results", [])
    };
};

const mapDispatchToProps = {
    getCategoryGroups,
    getCategories,
    deleteCategoryGroup,
    deleteCategory
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CategoryGroupListing);